import { createSelector } from '@reduxjs/toolkit';
import { useSelector } from 'react-redux';

/**
 * Surface level checking the display_schema looks how we expect it to.
 *
 * Note: Does not check actual contents of the schema
 * @param {*} schema
 * @returns boolean determining if valid schema
 */
export const isValidSchemaType = schema => {
  if (!schema) {
    return false;
  }

  if (typeof schema === 'string' || Array.isArray(schema)) {
    return false;
  }

  if (Object.keys(schema).length === 0) {
    return false;
  }

  return true;
};

// Memoized selector for processing additional data
const selectProcessedAdditionalData = createSelector(
  [
    (state, callerID) =>
      state.emergencyCalls.callQueue[callerID]?.additionalData,
    state => state.displaySchemaApi.queries,
  ],
  (additionalData, displaySchemaQueries) => {
    if (!additionalData) {
      return null;
    }

    let newObject = {};

    Object.keys(additionalData).forEach(org => {
      newObject[org] = [];

      additionalData[org].forEach(dataSet => {
        if (
          !isValidSchemaType(dataSet.display_schema) &&
          dataSet.display_schema_url
        ) {
          newObject[org].push({
            ...dataSet,
            display_schema:
              displaySchemaQueries[
                `getDisplaySchema("${dataSet.display_schema_url}")`
              ]?.data,
          });
        } else if (isValidSchemaType(dataSet.display_schema)) {
          newObject[org].push(dataSet);
        } else {
          newObject[org].push({
            ...dataSet,
            display_schema: null,
          });
        }
      });
    });

    return newObject;
  },
);

/**
 * Emergency Calls additionalData handling. Also handles looking through displaySchemaApi
 * if there is only a display_schema_url
 * @param {string} callerID
 * @returns Modified additionalData object
 */
const useAdditionalData = callerID => {
  const result = useSelector(state =>
    selectProcessedAdditionalData(state, callerID),
  );

  return result;
};

export default useAdditionalData;
